import {SvgIconProps} from "@mui/material";
import React, {ReactNode} from "react";
import AbstractIcon from "../AbstractIcon";


class ActiveResourceMain extends AbstractIcon {

    public renderDraw(props: SvgIconProps): ReactNode {
        return (
            <g>
                <path d="m 4,5 v 5 H 5 V 5 Z"/>
                <path d="M 6,6 V 9 H 7 V 6 Z"/>
                <path d="m 8,3 v 9 H 9 V 3 Z"/>
                <path d="m 10,4 v 7 h 1 V 4 Z"/>
                <path d="m 12,2 v 11 h 1 V 2 Z"/>
                <path d="m 14,5 v 5 h 1 V 5 Z"/>
                <path d="m 16,6 v 3 h 1 V 6 Z"/>
                <path d="m 18,4 v 7 h 1 V 4 Z"/>
                <path d="M 2,6 V 9 H 3 V 6 Z"/>
                <path d="m 20,6 v 3 h 1 V 6 Z"/>
                <path d="m 22,7 v 1 h 1 V 7 Z"/>
                <path d="M 14,16.999731 C 14,14.24438 14.009,11.99 14.02003,11.99 c 0.01101,0 0.470981,0.260568 1.022144,0.579039 1.604779,0.927269 2.085072,1.204379 3.199249,1.845846 1.292163,0.743942 2.844996,1.640892 3.305251,1.909189 0.189144,0.110259 0.520148,0.301787 0.735562,0.425618 0.215414,0.123831 0.391663,0.235078 0.391663,0.247219 0,0.01215 -0.3396,0.2175 -0.754668,0.456357 -0.764455,0.439919 -1.216941,0.701636 -1.80547,1.044284 -0.553534,0.322274 -0.78584,0.456539 -1.948761,1.126323 -0.619974,0.357073 -1.787625,1.031041 -2.59478,1.497707 -0.807155,0.466666 -1.490655,0.857347 -1.518888,0.868181 -0.04281,0.01643 -0.05133,-0.812177 -0.05133,-4.990032 z"/>
            </g>
        );
    }

}


export default ActiveResourceMain;